export interface NewsItem {
  id: string;
  title: string;
  date: string;
  author: string;
  category: string;
  excerpt: string;
  cover: string;
  tags: string[];
  content: string[];
  relatedIds: string[];
}

export const news: NewsItem[] = [
  {
    id: "1",
    title: "《聚会的目的》口碑持续走高：一场饭局为何让观众集体沉默",
    date: "2024-10-08",
    author: "本站影讯编辑部",
    category: "影市观察",
    excerpt:
      "上映两周以来，《聚会的目的》凭借扎实的剧本与克制的表演收获了广泛好评。许多观众表示，影片后半程的沉默比任何台词都更有力量。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20dimly%20lit%20dining%20table%20with%20empty%20chairs%20and%20warm%20lamp%20light%2C%20cinematic%20mood%2C%20deep%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric%20background&width=1200&height=675&seq=n-cover-01&orientation=landscape",
    tags: ["聚会的目的", "口碑", "影市"],
    content: [
      "自上映以来，《聚会的目的》在观众与影评人之间持续发酵。这部几乎全程发生在一张餐桌旁的作品，用极简的场景和密集的对话，讲述了一群老同学十年后的重逢。",
      "## 一场没有标准答案的聚会",
      "影片没有给出谁对谁错的判断，而是把解释权交还给观众。许多人在社交平台上分享说，散场后久久无法离席，因为银幕上的尴尬与沉默，让他们想起了自己那些没能赴约的重逢。",
      "## 表演被反复提及",
      "四位主演的内敛表演成为讨论焦点，尤其是程屿这个『始终沉默』的角色，被不少观众称为全片情绪的支点。有影评指出，这种不依赖台词的表演，在国产都市题材里颇为少见。",
      "随着排片与话题的双重推动，影片的讨论热度仍在上升。编辑部也将持续跟进相关解读与主创访谈。",
    ],
    relatedIds: ["2", "5", "7"],
  },
  {
    id: "2",
    title: "从饭桌到人生：解读《聚会的目的》的四个隐藏细节",
    date: "2024-10-06",
    author: "特约撰稿人 梁砾",
    category: "深度解读",
    excerpt:
      "餐桌上的摆件、反复出现的旧照片、程屿的手表……这些看似随意的道具，其实都是导演埋下的线索。本文带你逐一拆解。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20close%20up%20of%20old%20photographs%20and%20small%20objects%20on%20a%20wooden%20table%20under%20warm%20light%2C%20cinematic%20still%20life%2C%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail&width=1200&height=675&seq=n-cover-02&orientation=landscape",
    tags: ["聚会的目的", "解读", "细节"],
    content: [
      "好的电影经得起二刷，而《聚会的目的》几乎是为二刷而生的。第一次看，你在意的是他们说出口的话；第二次看，你会发现真正重要的全在那些没说出口的地方。",
      "## 一、桌上的第四把椅子",
      "聚会明明只有四个人，桌上却始终摆着一副多余的餐具。这个细节在开场就点明了『缺席者』的存在，也为后续的情感走向埋下伏笔。",
      "## 二、反复出现的旧照片",
      "那张被反复拿起又放下的旧照片，是全片的核心道具。它的每一次出现，都对应着人物关系的一次松动。",
      "## 三、程屿的手表",
      "细心的人会发现，程屿几乎全程都在看表。这不是不耐烦，而是一种倒计时的焦虑——他比任何人都清楚，这场聚会终将结束。",
      "## 四、最后一盏灯",
      "结尾时，餐厅的灯一盏盏熄灭，只有靠窗那盏留着。这既是空间的真实，也是情绪的隐喻：总要有一个人，为过去留一束光。",
    ],
    relatedIds: ["1", "8", "10"],
  },
  {
    id: "3",
    title: "类型片观察：国产悬疑为何越来越擅长『空间叙事』",
    date: "2024-09-28",
    author: "本站影讯编辑部",
    category: "行业观察",
    excerpt:
      "从《午夜来客》到《迷雾码头》，越来越多国产悬疑片选择把故事压缩在有限空间里。这种变化背后，藏着创作者怎样的思考？",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20dark%20narrow%20hallway%20lit%20by%20a%20single%20light%20with%20long%20shadows%2C%20cinematic%20mood%2C%20deep%20navy%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric&width=1200&height=675&seq=n-cover-03&orientation=landscape",
    tags: ["悬疑", "行业观察", "类型片"],
    content: [
      "近两年，越来越多的国产悬疑片开始放弃大场面，转而把故事收进一间屋子、一趟车、一个夜晚。空间的压缩，反而带来了张力的放大。",
      "## 有限空间，无限焦虑",
      "当人物无法离开，观众也随之被困在同一个空间里。这种沉浸式的压迫感，是宽泛场景难以替代的。",
      "## 成本与表达的双赢",
      "有限空间意味着更可控的制作成本，也让创作者把精力集中在剧本与表演上。《午夜来客》就是这一思路的典型代表。",
      "可以预见，在追求质感与效率的共同驱动下，『空间叙事』还会继续影响国产类型片的走向。",
    ],
    relatedIds: ["4", "1", "2"],
  },
  {
    id: "4",
    title: "专访导演许格：《午夜来客》想拍的不是恐怖，而是信任的崩塌",
    date: "2024-09-20",
    author: "特约撰稿人 沈云初",
    category: "主创访谈",
    excerpt:
      "在这部几乎只发生在一间公寓里的悬疑片背后，导演许格谈到了他对空间、声音与信任的理解。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20film%20director%20seated%20in%20a%20dim%20studio%20with%20soft%20side%20light%2C%20cinematic%20portrait%20mood%2C%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric&width=1200&height=675&seq=n-cover-04&orientation=landscape",
    tags: ["午夜来客", "访谈", "导演"],
    content: [
      "《午夜来客》上映后，观众讨论最多的不是反转，而是那股挥之不去的窒息感。导演许格说，这正是他想要的东西。",
      "## 『我最怕的是安静』",
      "许格坦言，影片里最吓人的不是敲门声，而是敲门之后的安静。那种不知道对方在想什么的空白，才是真正的恐惧来源。",
      "## 关于信任",
      "他把整部电影理解为一个关于信任崩塌的过程：当最亲近的人也开始有所隐瞒，家就不再是安全的。",
      "谈及未来，许格表示还会继续在有限空间里做文章，但希望每一部都能找到新的角度。",
    ],
    relatedIds: ["1", "3", "8"],
  },
  {
    id: "5",
    title: "《第七个夏天》定档：一个家庭与七个夏天的告别",
    date: "2024-07-01",
    author: "本站影讯编辑部",
    category: "新片定档",
    excerpt:
      "由何蔚然执导的家庭题材电影《第七个夏天》正式定档，影片以一个家庭连续七个夏天的相聚，讲述关于离别与和解的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20sunlit%20old%20house%20with%20green%20shutters%20and%20a%20garden%20in%20summer%2C%20warm%20nostalgic%20light%2C%20amber%20and%20navy%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric&width=1200&height=675&seq=n-cover-05&orientation=landscape",
    tags: ["第七个夏天", "定档", "家庭"],
    content: [
      "家庭题材新片《第七个夏天》日前正式宣布定档。影片由何蔚然执导，讲述一个普通家庭连续七个夏天在同一栋老屋度过假期的故事。",
      "## 用时间讲故事",
      "导演表示，影片的结构看似重复，但每一年的夏天都在悄悄改变人物之间的关系。这种耐心的叙事，是影片最大的特点。",
      "## 群像与情感",
      "片中四个孩子的成长线并行展开，既有争吵也有和解。片方形容这是一部『适合带着家人一起看』的电影。",
      "影片将在暑期档与观众见面，更多物料也将陆续释出。",
    ],
    relatedIds: ["7", "10", "1"],
  },
  {
    id: "6",
    title: "年度片单推荐：五部适合深夜独自观看的文艺电影",
    date: "2024-06-15",
    author: "编辑 温言",
    category: "片单推荐",
    excerpt:
      "如果你也在寻找那种安静、克制却后劲十足的观影体验，这份片单或许适合你。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20quiet%20room%20at%20night%20with%20a%20lamp%20a%20book%20and%20a%20warm%20cup%2C%20cozy%20cinematic%20mood%2C%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric&width=1200&height=675&seq=n-cover-06&orientation=landscape",
    tags: ["片单", "推荐", "文艺"],
    content: [
      "有些电影不适合热闹的场合，只属于一个人的深夜。以下五部作品，都带着安静却持久的余味。",
      "## 一、《未寄出的信》",
      "关于遗憾与勇气，慢得恰到好处，适合在一个雨夜观看。",
      "## 二、《无声告白》",
      "用听觉的失去，讲述人与人之间沟通的困境，安静却极具爆发力。",
      "## 三、《失落的胶片》",
      "一场关于记忆的考证，写给胶片时代的情书。",
      "## 四、《春天不回来》",
      "青春、小城与告别，干净克制，看完会想很多。",
      "## 五、《明日之前》",
      "用末日前夕的一晚，重新理解何为珍贵。",
    ],
    relatedIds: ["2", "8", "11"],
  },
  {
    id: "7",
    title: "《明日之前》幕后：那个黎明前的长镜头是如何拍成的",
    date: "2024-10-10",
    author: "特约撰稿人 梁砾",
    category: "幕后揭秘",
    excerpt:
      "被观众称为『全片最美画面』的黎明长镜头，背后是剧组连续七个夜晚的等待与尝试。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20empty%20city%20street%20just%20before%20dawn%20with%20a%20faint%20glow%20on%20the%20horizon%2C%20cinematic%20mood%2C%20deep%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric&width=1200&height=675&seq=n-cover-07&orientation=landscape",
    tags: ["明日之前", "幕后", "拍摄"],
    content: [
      "《明日之前》上映后，结尾那个穿行于黎明前城市的长镜头被反复提及。很少有人知道，这个画面拍了整整七个夜晚。",
      "## 等一个刚好合适的光",
      "摄影师回忆，为了捕捉天光将亮未亮的那一刻，剧组每天凌晨三点出发，只为守住那不到二十分钟的窗口。",
      "## 一次走位，一条过",
      "由于天光变化太快，长镜头几乎没有重来的机会。演员与摄影团队反复排练走位，最终在第六个夜晚拍到了满意的一条。",
      "导演说，他想要的是那种『世界就要改变，但一切又很平静』的感觉。",
    ],
    relatedIds: ["12", "1", "3"],
  },
  {
    id: "8",
    title: "影评观点：《无声告白》里的沉默，比声音更响",
    date: "2024-05-22",
    author: "特约撰稿人 沈云初",
    category: "影评观点",
    excerpt:
      "一部关于听觉的电影，却让观众在无声中听见了最多的情绪。本文从声音设计的角度，聊聊这部被低估的作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20quiet%20room%20with%20sheer%20curtains%20and%20soft%20window%20light%2C%20minimal%20cinematic%20mood%2C%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric&width=1200&height=675&seq=n-cover-08&orientation=landscape",
    tags: ["无声告白", "影评", "声音设计"],
    content: [
      "《无声告白》最聪明的地方，是它把『听不见』变成了叙事的语言，而不是单纯的设定。",
      "## 声音的减法",
      "随着女主角听力的一点点下降，影片的环境音也在一层层被剥离。观众感受到的，正是她感受到的世界。",
      "## 沉默的重量",
      "片中最动人的几场戏，几乎没有对白。人物之间的爱与疏离，全靠眼神与停顿传递。",
      "如果说声音设计是隐藏的主角，那么沉默就是它的高光时刻。",
    ],
    relatedIds: ["2", "6", "11"],
  },
  {
    id: "9",
    title: "行业观察：小成本电影如何靠口碑逆袭",
    date: "2024-04-18",
    author: "本站影讯编辑部",
    category: "行业观察",
    excerpt:
      "没有大明星、没有大场面，一些电影却靠着扎实的口碑慢慢走红。这种『慢热型』成功，正在改变市场的判断方式。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20cinema%20hall%20with%20rows%20of%20empty%20red%20seats%20and%20a%20glowing%20screen%2C%20cinematic%20mood%2C%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric&width=1200&height=675&seq=n-cover-09&orientation=landscape",
    tags: ["行业观察", "口碑", "小成本"],
    content: [
      "过去，电影的成败往往在首映周就见分晓。但现在，越来越多小成本作品靠着口碑实现逆袭。",
      "## 观众变了",
      "当社交平台让分享变得容易，一部『值得推荐』的电影，可以在上映数周后依然保持热度。",
      "## 内容回归本位",
      "没有流量加持时，剧本与表演就成了唯一的筹码。这也倒逼创作者把功夫花在刀刃上。",
      "对于观众而言，这无疑是一件好事：我们正在被更多认真讲故事的电影找到。",
    ],
    relatedIds: ["3", "5", "10"],
  },
  {
    id: "10",
    title: "美食与电影：为什么我们总在银幕前被一碗热汤打动",
    date: "2024-03-30",
    author: "编辑 温言",
    category: "趣味话题",
    excerpt:
      "从《老街餐厅》里的家常小炒，到无数电影中冒着热气的饭菜，食物为何总能成为情感的载体？",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20steaming%20bowl%20of%20soup%20on%20a%20wooden%20table%20under%20warm%20light%2C%20cozy%20cinematic%20food%20still%20life%2C%20navy%20and%20amber%20tones%2C%20film%20grain%2C%20high%20detail&width=1200&height=675&seq=n-cover-10&orientation=landscape",
    tags: ["美食", "话题", "老街餐厅"],
    content: [
      "在很多电影里，一顿饭往往比一段对白更能说明问题。热气腾腾的食物，天然带着『被照顾』的温度。",
      "## 一碗汤的距离",
      "《老街餐厅》里，老板给每位老顾客都记得口味。这种无需言说的默契，就是最朴素的关心。",
      "## 吃饭是一场仪式",
      "当人们围坐在同一张桌子前，关系的亲疏也就摆在明面上了。谁坐在哪里、谁给谁夹菜，都是无声的叙事。",
      "也许正因为食物如此日常，它才最能击中人心里最柔软的地方。",
    ],
    relatedIds: ["10", "7", "5"],
  },
];